/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
  cancel: {
    id: 'cancel',
    defaultMessage: 'Cancel'
  },
  submit: {
    id: 'submit',
    defaultMessage: 'Submit'
  },
  defaultApiErrorMessage: {
    id: 'defaultApiErrorMessage',
    defaultMessage: 'A problem occured while processing your request.',
  },
  invalidCart: {
    id: 'invalidCart',
    defaultMessage: 'Invalid cart request.'
  },
  invalidResearcherName: {
    id: 'invalidResearcherName',
    defaultMessage: 'The researcher name length is invalid. It\'s length must be less than or equal to 30.'
  },
  invalidOligoName: {
    id: 'invalidOligoName',
    defaultMessage: 'The oligo name length is invalid. It\'s length must be less than or equal to 30.'
  },
  invalidSetting: {
    id: 'invalidSetting',
    defaultMessage: 'Invalid oligo plate configuration setting.'
  }
});
